export abstract class DeleteInviteStrategy {
  abstract deleteInvite(): Promise<void>;
}
